import { useMemo } from 'react'

import AuthHelper from 'helpers/auth_helper'

// multiple usages
const useOtherParticipant = (participants = []) => {
  const otherParticipant = useMemo(() => {
    return participants.find(p => p.swipecast_user_id !== AuthHelper.logged_in_profileID)
  }, [participants])

  return otherParticipant
}

export default useOtherParticipant
